<template>
  <template-info :bgImg="bgImg" title="ถ้าถูกตรวจเจอจะเป็นอย่างไร">
    <div class="pb-detail">
      <span>
        ถ้าไม่ส่งภาษีให้ถูกต้อง <br />
        จะเกิดอะไรขึ้น
      </span>
      <br /><br />
      <span> แน่นอน... <span class="red bold">ผิดกฎหมาย</span> </span>
      <br /><br />
      <span>
        และหากถูกตรวจพบจะต้องเสียเบี้ยปรับและเงินเพิ่ม <br />
        รวมทั้งถ้าเป็นกรณี <span class="red">"จงใจหรือแจ้งข้อความเท็จ"</span>
        <br />
        มีโทษจำคุกตั้งแต่ 3 เดือนถึง 7 ปี
      </span>
      <br /><br />
      <chevron-right-link
        class="desktop-size"
        @clickLink="goToFineDetail"
        caption="รายละเอียดค่าปรับต่างๆ"
        style="margin-bottom: 10px;"
      />
    </div>
  </template-info>
</template>

<script>
import BackgroundImg from "@/assets/images/infos/penalty.png";

export default {
  name: "Penalty",
  components: {},
  data() {
    const bgImg = BackgroundImg;
    return {
      bgImg: bgImg,
    };
  },
  methods: {
    goToFineDetail() {
      this.$router.push({
        path: "/info/fine_detail",
      });
    },
  },
};
</script>

<style scoped>
.pb-detail {
  width: 100%;
  color: #393d43;
  margin-bottom: 20px;
  text-align: left;
}
.bold {
  font-weight: bold;
}
.red {
  color: #f45a49;
}
@media (min-width: 600px) {
  .pb-detail br {
    display: none;
  }
  .desktop-size {
    margin-top: 16px;
  }
}
</style>
